module.exports = __webpack_public_path__ + "img/reimu hakurei scarlet_sc1.f9b61c2d.png";